import React from "react"
import {
    ConditionalRenderContainer,
    HorizontalStack,
    HeadingMedium,
} from "@mallardbay/lib-react-components"
import type { StyleProps } from "@mallardbay/lib-react-components"

import { getListingTypeCamelcase } from "~utils/helpers"
import { ListingType } from "~graphql/generated/graphql"
import {
    TextBold,
    TextSmallNote,
    TextSmallSecondary,
} from "~components/shared/todo-lib-react-components/text"
import { VerticalStack } from "~components/shared/todo-lib-react-components/vertical-stack"
import AspectRatioImage from "~components/shared/todo-lib-react-components/aspect-ratio-image"
import COPY from "~config/copy-constants"

export interface BookingSummaryHeaderProps {
    readonly title?: string | null
    readonly note?: string | null
    readonly imageUrl: string
    readonly listingTitle?: string | null
    readonly listingType?: ListingType | null
    readonly locationState?: string
    readonly shouldHideListingHeader?: boolean
}

export default function BookingSummaryHeader({
    title,
    note,
    imageUrl,
    listingType,
    listingTitle = "",
    locationState = "",
    shouldHideListingHeader = false,
}: BookingSummaryHeaderProps) {
    const styles = useStyles()
    const formattedListingType = getListingTypeCamelcase(
        listingType ?? ListingType.BlastCast
    )

    return (
        <VerticalStack>
            <HeadingMedium>{title ?? COPY.TRIP_SUMMARY}</HeadingMedium>
            <ConditionalRenderContainer shouldRender={!shouldHideListingHeader}>
                <HorizontalStack>
                    <AspectRatioImage
                        style={styles.image}
                        ratio={4 / 3}
                        src={imageUrl}
                    />
                    <div>
                        <TextBold>{listingTitle}</TextBold>
                        <TextSmallSecondary>
                            {formattedListingType} trip in {locationState}
                        </TextSmallSecondary>
                    </div>
                </HorizontalStack>
            </ConditionalRenderContainer>
            {note && <TextSmallNote>{note}</TextSmallNote>}
        </VerticalStack>
    )
}

function useStyles() {
    const image: StyleProps = {
        width: "120px",
    }

    return { image }
}
